export const buildProductLinkLabel = (product, { priceLabel = null, rank = null } = {}) => {
  const name = product?.name?.trim() || "product";
  const parts = [`View ${name}`];

  if (priceLabel) {
    parts.push(priceLabel);
  }

  if (rank != null) {
    parts.push(`rank ${rank}`);
  }

  return parts.join(", ");
};
